import React from 'react';
import { string, node } from 'prop-types';
import { FeatureBasedRecommendationsImporter } from '../components/component/FeatureBasedRecommendationsImporter';

const ZoneCard = ({ children }) => {
  return <div className="sui-overflow-hidden sui-max-w-full">{children}</div>;
};

export const PIPFeatureBasedRecommendationsImporter = ({ itemId }) => {
  return (
    <FeatureBasedRecommendationsImporter
      hideOnMobile
      itemId={itemId}
      errorBoundary
      hydrator={{
        tag: ZoneCard,
        className: 'grid'
      }}
      dynamic={{
        pageType: 'pip',
      }}
    />
  );
};

ZoneCard.propTypes = {
  children: node.isRequired
};

PIPFeatureBasedRecommendationsImporter.propTypes = {
  itemId: string.isRequired
};

PIPFeatureBasedRecommendationsImporter.displayName = 'PIPFeatureBasedRecommendationsImporter';
